import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ErrorModule } from 'src/app/components/error/error.module';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { IconsModule } from 'src/app/icons/icons.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { DatepickerModule } from 'src/app/components/datepicker/datepicker.module';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SecretComponent } from './secret.component';
import { MatDividerModule } from '@angular/material/divider';
import { DynamicFormModule } from '../dynamic-form/dynamic-form.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@NgModule({
  declarations: [SecretComponent],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatDatepickerModule,
    MatInputModule,
    MatChipsModule,
    MatAutocompleteModule,
    ErrorModule,
    IconsModule,
    DatepickerModule,
    MatDividerModule,
    DynamicFormModule,
    MatProgressSpinnerModule
  ],
  exports: [
    SecretComponent
  ]
})
export class SecretModule { }
